import React, { Component } from 'react'

import { checkValidity } from '../../../../../helpers/utils'
import { connect } from 'react-redux'
import * as actions from '../../../../../store/actions/index'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'

import Card from '../../../../../components/UI/Card/Card'
import SpanningTable from './weightTable'
import { withTranslate } from 'react-redux-multilingual'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
// import StepContent from '@material-ui/core/StepContent'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import SetLevel from './SetLevel/SetLevel'
import SetChief from './SetChief/SetChief'
class SetWeight extends Component {
  state = {
    open: false,
    elementType: 'tableInput',
    value: this.props.weight,
    level_group: null,
    validation: {
      limitTo100: true
    },
    errorMessage: [],
    header: {
      label: this.props.translate('setWeight'),
      toggle: {
        value: false,
        label: 'Edit'
      }
    },
    weight: {
      col: {
        label: this.props.translate('structure'),
        key: '',
        data: []
      },
      row: {
        label: this.props.translate('levelGroup'),
        key: '',
        data: []
      }
    },
    assessor: [],
    chief: [],
    row: 0,
    competencys_id: 0,
    updateProps: {
      param: this.props.param,
      levelTable: this.props.levelTable
    },
    level_structures: [],
    allData: [],
    levelWeight: [],
    activeStep: 0,
    selectAss: [],
    assessor_group: [],
    saveData: [],
    selectWeight: [],
    positionCh: [],
    validdddd: false,
    save: true
  }

  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state

    let saveData = () => {
      let savee = []
      if (state.allWeight) {
        let save = state.allWeight.filter(item => item.weight_percent !== 0)
        savee = save.map(item => {
          if (item.assessor_group_criteria.length !== 0) {
            let cheif = item.assessor_group_criteria.map(ch => {
              let test = []

              if (ch?.level_position_group && ch?.level_position_group?.length !== 0) {
                ch.level_position_group.map(le => {
                  let val = le.value.filter(
                    val =>
                      (val.weight_percent !== 0 || item.weight_percent === '.00') &&
                      val.weight_percent !== ''
                  )

                  let rr = val.map(ad => {
                    return {
                      case_id: le.case_id,
                      action2_position_group_id: ad.position_group_id
                        ? ad.position_group_id
                        : ad.action2_position_group_id,
                      weight_percent: ad.weight_percent
                    }
                  })
                  test = test.concat(rr)
                  return le
                })
                if (
                  // ch.weight_percent !== 0 &&
                  ch.weight_percent !== undefined &&
                  ch.weight_percent !== ''
                ) {
                  return {
                    assessor_group_id: ch.value_list_id ? ch.value_list_id : ch.assessor_group_id,
                    weight_percent: ch.weight_percent,
                    level_position_group: test
                  }
                } else {
                  return null
                }
              } else if (
                // ch.weight_percent !== 0 &&
                ch.weight_percent !== undefined &&
                ch.weight_percent !== ''
              ) {
                return {
                  assessor_group_id: ch.value_list_id ? ch.value_list_id : ch.assessor_group_id,
                  weight_percent: ch.weight_percent,
                  level_position_group: []
                }
              } else {
                return null
              }
            })
            cheif = cheif.filter(cce => cce !== null)
            return {
              ...item,
              assessor_group_criteria: cheif
            }
          } else if (
            // item.weight_percent !== 0 &&
            item.weight_percent !== undefined &&
            item.weight_percent !== '' &&
            !item.value_list_id
          ) {
            return item
          } else {
            return null
          }
        })
        savee = savee.map(item => {
          item = {
            ...item,
            kpi: item.kpi_criteria,
            competency: item.competency_criteria
          }
          delete item.competency_criteria
          delete item.kpi_criteria
          return item
        })
      }

      props.saveData(savee)
    }

    if (props.save !== state.save) {
      saveData()
      props.saveSuccess()
    }
    if (props.param === null) {
      let { col, row } = state.weight
      let { toggle } = state.header
      updatedState = {
        ...updatedState,
        open: false,
        weight: {
          ...updatedState.weight,
          col: { ...col, data: [] },
          row: { ...row, data: [] }
        },
        errorMessage: [],
        assessor: [],
        chief: [],
        row: 0,
        header: {
          ...state.header,
          toggle: {
            ...toggle,
            value: false
          }
        },
        competencys_id: 0,
        updateProps: {
          ...updateProps,
          levelTable: props.levelTable,
          param: props.param
        }
      }
    }
    if (
      (props.param?.company_id !== updateProps.param?.company_id ||
        props.param?.appraisal_type_id !== updateProps.param?.appraisal_type_id) &&
      props.param !== null
    ) {
      props.fetchLevelTableOptions(props.param)
      updatedState = {
        ...updatedState,
        updateProps: {
          ...updateProps,
          param: props.param
        }
      }
    }

    if (props.weight !== state.value) {
      updatedState = {
        ...updatedState,
        value: props.weight
      }
    }
    if (props.levelTable !== updateProps.levelTable) {
      let { level_group, structure, assessor, position_group } = props.levelTable
      let { weight } = state
      let { col, row } = weight
      let errorMessage = level_group.map(res => {
        return {
          level_group_id: res.level_group_id,
          error: null,
          isValid: false
        }
      })
      updatedState = {
        ...updatedState,
        weight: {
          ...updatedState.weight,
          col: { ...col, data: structure },
          row: { ...row, data: level_group }
        },
        errorMessage,
        assessor,
        chief: position_group,

        open: true,
        competencys_id: structure.find(
          find =>
            find.structure_type.value_list_code === 'STT02' ||
            find.structure_type.value_list_code === 'STT06' ||
            find.structure_type.value_list_code === 'STT05'
        )?.structure_id,
        updateProps: {
          ...updateProps,
          levelTable: props.levelTable
        }
      }
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let newCriteriaData = Object.entries(state.inputGroups).reduce((criteriaGroups, criteria) => {
        let [criteriaKey, criteriaAttrs] = criteria
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null

        if (criteriaAttrs.elementType === 'checkbox') {
          value = 0
        }
        if (props.selectedRecord && props.selectedRecord[criteriaKey]) {
          value = props.selectedRecord[criteriaKey]

          let { isValid, error } = checkValidity(
            value,
            criteriaAttrs.validation,
            criteriaAttrs.label
          )

          valid = isValid
          errorMessage = error
        }

        const newCriteriaAttrs = {
          ...criteriaAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return {
          ...criteriaGroups,
          [criteriaKey]: { ...newCriteriaAttrs }
        }
      }, {})
      updatedState = {
        ...updatedState,
        inputGroups: newCriteriaData,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      }
    }
    return updatedState
  }

  getSteps() {
    return [
      this.props.translate('setWeight'),
      this.props.translate('setAssessor'),
      this.props.translate('setPosition')
    ]
  }

  inputChanged(col, row, weight) {
    let selectWeight = weight.find(item => item.level_group_id === row && item.structure_id === col)

    this.setState({
      selectWeight: selectWeight,
      saveData: weight
    })

    this.setState({
      allWeight: weight,
      selectAss: {
        col: col,
        row: row
      }
    })
    this.handleNext(col, row)
  }

  weigthChanged(weight) {
    this.setState({
      allWeight: weight
    })
  }

  getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <SpanningTable
            selected={this.props.selected}
            weightAll={this.state.allWeight}
            data={this.state.weight}
            saveAllTable={data => this.saveAllTable(data)}
            weigthChanged={data => this.weigthChanged(data)}
            handleNext={(col, row, weight) => this.inputChanged(col, row, weight)}
            edit={valid => this.checkEdit(valid)}
          />
        )
      case 1:
        return (
          <SetLevel
            selected={this.props.selected}
            weightAll={this.state.allWeight}
            data={this.state.weight}
            selectAss={this.state.selectAss}
            levelTable={this.props.levelTable}
            assessor_group={this.state.assessor_group}
            Next={() => this.handleNext()}
            saveAss={assessor_group => this.saveAss(assessor_group)}
          />
        )
      case 2:
        return (
          <SetChief
            selected={this.props.selected}
            weightAll={this.state.allWeight}
            positionCh={this.state.positionCh}
            selectWeight={this.state.selectWeight}
            data={this.state.weight}
            levelTable={this.props.levelTable}
            finish={data => this.saveAllData(data)}
            Savee={data => this.saveData(data)}
            assessor_group={this.state.assessor_group}
            valid={valid => this.props.valid(valid)}
          />
        )
      default:
        return 'Unknown step'
    }
  }

  checkEdit = valid => {
    this.props.valid(valid)
  }
  saveAllTable = data => {
    this.setState({
      allWeight: data
    })
  }
  saveAllData = data => {
    let save = data
      .filter(item => item.weight_percent !== '' && item.weight_percent)
      .map(item => {
        let savechi = []
        // let saveche =[]
        item.level_position_group.map(ch => {
          ch.value
            .filter(val => val.weight_percent !== 0 && val.weight_percent)
            .map(bb => {
              savechi.push({
                case_id: ch.case_id,
                action2_position_group_id: bb.position_group_id,
                weight_percent: bb.weight_percent
              })
              return {
                case_id: ch.case_id,
                action2_position_group_id: bb.position_group_id,
                weight_percent: bb.weight_percent
              }
            })
          return ch
        })
        return {
          assessor_group_id: item.value_list_id,
          weight_percent: item.weight_percent,
          level_position_group: savechi
        }
      })

    let up = {
      ...this.state.selectWeight,
      assessor_group_criteria: save
    }

    let down = {
      ...this.state.selectWeight,
      assessor_group_criteria: data
    }

    let rr = this.state.allWeight.map(item => {
      if (
        item.structure_id === this.state.selectWeight.structure_id &&
        item.level_group_id === this.state.selectWeight.level_group_id
      ) {
        return down
      } else {
        return item
      }
    })

    let test = this.state.allWeight
    test.map(item => {
      if (
        item.structure_id === this.state.selectWeight.structure_id &&
        item.level_group_id === this.state.selectWeight.level_group_id
      ) {
        return up
      } else {
        return item
      }
    })

    this.setState({
      allWeight: rr,
      positionCh: rr
    })
  }
  saveData = () => {
    let save = this.state.allWeight.filter(item => item.weight_percent !== 0)
    let savee = save.map(item => {
      if (item.assessor_group_criteria.length !== 0) {
        let cheif = item.assessor_group_criteria.map(ch => {
          let test = []

          if (ch?.level_position_group?.length !== 0) {
            ch.level_position_group.map(le => {
              let val = le.value.filter(
                val =>
                  (val.weight_percent !== 0 || item.weight_percent === '.00') &&
                  val.weight_percent !== ''
              )

              let rr = val.map(ad => {
                return {
                  case_id: le.case_id,
                  action2_position_group_id: ad.position_group_id
                    ? ad.position_group_id
                    : ad.action2_position_group_id,
                  weight_percent: ad.weight_percent
                }
              })
              test = test.concat(rr)
              return le
            })
            if (
              // ch.weight_percent !== 0 &&
              ch.weight_percent !== undefined &&
              ch.weight_percent !== ''
            ) {
              return {
                assessor_group_id: ch.value_list_id ? ch.value_list_id : ch.assessor_group_id,
                weight_percent: ch.weight_percent,
                level_position_group: test
              }
            } else {
              return null
            }
          } else if (
            // ch.weight_percent !== 0 &&
            ch.weight_percent !== undefined &&
            ch.weight_percent !== ''
          ) {
            return {
              assessor_group_id: ch.value_list_id ? ch.value_list_id : ch.assessor_group_id,
              weight_percent: ch.weight_percent,
              level_position_group: []
            }
          } else {
            return null
          }
        })
        cheif = cheif.filter(cce => cce !== null)
        return {
          ...item,
          assessor_group_criteria: cheif
        }
      } else if (
        // item.weight_percent !== 0 &&
        item.weight_percent !== undefined &&
        item.weight_percent !== '' &&
        !item.value_list_id
      ) {
        return item
      } else {
        return null
      }
    })

    this.props.saveData(savee)
  }
  saveAss = assessor_group => {
    let save = this.state.allWeight.map(item => {
      if (
        item.level_group_id === this.state.selectAss.row &&
        item.structure_id === this.state.selectAss.col
      ) {
        return {
          ...item,
          assessor_group_criteria: assessor_group
        }
      } else {
        return item
      }
    })

    this.setState({
      allWeight: save,
      assessor_group: assessor_group
    })
  }

  handleNext = (col, row, value) => {
    let check = this.props.levelTable.structure.find(item => item.structure_id === col)

    if (
      check &&
      check.structure_type.value_list_code !== 'STT02' &&
      check.structure_type.value_list_code !== 'STT06' &&
      check.structure_type.value_list_code !== 'STT05'
    ) {
      let assessor_group = this.props.levelTable.assessor
        .filter(item => item.value_list_id === 1)
        .map(ass => {
          return { ...ass, weight_percent: 100 }
        })
      this.setState({
        assessor_group: assessor_group
      })
      this.setState(state => ({
        activeStep: state.activeStep + 2
      }))
    } else {
      this.setState(state => ({
        activeStep: state.activeStep + 1
      }))
    }
  }

  handleBack = () => {
    let check = this.props.levelTable.structure.find(
      item => item.structure_id === this.state.selectAss.col
    )
    if (
      (check &&
        check.structure_type.value_list_code !== 'STT02' &&
        check.structure_type.value_list_code !== 'STT06' &&
        check.structure_type.value_list_code !== 'STT05') ||
      this.state.activeStep === 2
    ) {
      this.setState(state => ({
        activeStep: state.activeStep - 2
      }))
    } else {
      this.setState(state => ({
        activeStep: state.activeStep - 1
      }))
    }
  }

  handleReset = () => {
    this.setState({
      activeStep: 0
    })
  }

  render() {
    const steps = this.getSteps()
    const { activeStep } = this.state

    return (
      <Aux>
        {!this.state.open ? null : (
          <Card>
            {/* <div> */}
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel>
                    <h2>{label}</h2>
                  </StepLabel>
                  {/* <StepContent>
                    <div>
                      {activeStep !== 0 ? (
                        <div>
                          <Button size='medium' onClick={this.handleBack}>
                            Back
                          </Button>
                        </div>
                      ) : null}
                    </div>
                  </StepContent> */}
                </Step>
              ))}
            </Stepper>
            {/* <div> {this.getStepContent(activeStep)} </div> */}
            <div>
              <div> {this.getStepContent(activeStep)} </div>
              {activeStep !== 0 ? (
                <div>
                  <Button size='medium' onClick={this.handleBack}>
                    {this.props.translate('back')}
                  </Button>
                </div>
              ) : null}
            </div>
            {activeStep === steps.length && (
              <Paper square elevation={0}>
                <Typography>All steps completed - you&apos;re finished</Typography>
                <Button onClick={this.handleReset}>Reset</Button>
              </Paper>
            )}
          </Card>
        )}
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    levelTable: state.criteria.levelTable,
    loading: state.criteria.loading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchLevelTableOptions: recordId => dispatch(actions.fetchLevelTable(recordId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetWeight))
